export default "__VITE_ASSET__BE99GV$d__"